import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const standardTemplate = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  organization,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const promptElement = findElementByName(elements, ELEMENT_NAMES.PROMPT);
  const nameAndTitleElement = findElementByName(elements, ELEMENT_NAMES.NAME_AND_TITLE);
  const companyLogoIntroElement = findElementByName(elements, ELEMENT_NAMES.COMPANY_LOGO_INTRO);
  const companyLogoOutroElement = findElementByName(elements, ELEMENT_NAMES.COMPANY_LOGO_OUTRO);
  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);

  const INTRO_DURATION = companyLogoIntroElement?.duration ?? 0;
  const OUTRO_DURATION = companyLogoOutroElement?.duration ?? 0;

  // Appy modifications first to have space for the video
  const videoDuration = calculateVideoDuration(mediaElements);
  await preview.applyModifications({
    [`${promptElement?.id}.text`]: story?.question?.question,
    [`${nameAndTitleElement?.id}.text`]: `${story?.creator?.name}\n${story?.creator?.title || ""}`,
    [`${companyLogoIntroElement?.id}.source`]: organization.logo.originalUrl,
    [`${companyLogoOutroElement?.id}.source`]: organization.logo.originalUrl,
    // small gap to show the logo in the outro
    [`${companyLogoOutroElement?.id}.time`]: videoDuration + INTRO_DURATION + 0.3,
    duration: videoDuration + INTRO_DURATION + OUTRO_DURATION
  });

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    x: storyVideoElement?.x,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    border_radius: storyVideoElement?.border_radius
  }, INTRO_DURATION);
  await deleteElement(preview, storyVideoElement?.id);
};

export default standardTemplate;
